const colorPalette ={   myBlue:'#20396F',
                        myYellow:'#FCC800',
                        myGrey:'#C5C5C5'
                    }

export {colorPalette}